import { render, staticRenderFns } from "./UploadBankDocumentsModal.vue?vue&type=template&id=296fac54&"
import script from "./UploadBankDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./UploadBankDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadBankDocumentsModal.vue?vue&type=style&index=0&id=296fac54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports